import { Button } from "antd";
import PasswordInput from "components/Form/PasswordInput";
import useChangePassword from "hooks/useChangePassword";

export default function ChangePassword() {
  const { control, handleSubmit, loading, onSubmit } = useChangePassword();

  return (
    <div className="w-full flex h-screen justify-center items-center px-4 py-4 bg-login bg-center bg-cover bg-no-repeat">
      <div className="w-full max-w-lg sm:m-0 m-4">
        <div
          className="w-full bg-white rounded-lg overflow-clip"
          style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
        >
          <div className="flex w-full flex-col items-center p-8">
            <div className="w-full flex flex-col gap-y-4">
              <h4 className="font-semibold text-lg">Change your password</h4>
            </div>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="w-full flex flex-col gap-y-4 mt-5"
            >
              <PasswordInput
                control={control}
                name="password"
                placeholder="Old Password"
              />
              <PasswordInput
                control={control}
                name="new_password"
                placeholder="New Password"
              />
              <PasswordInput
                control={control}
                name="confirm_password"
                placeholder="Confirm Password"
              />

              <div className="w-full">
                <Button
                  loading={loading}
                  htmlType="submit"
                  type="primary"
                  className="py-2 px-8 rounded-md float-right h-auto font-medium w-fit shadow-none"
                >
                  Change Password
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
